<div *ngIf="viewAccess" #displayStructure></div>
<div class="not-access-text" *ngIf="!viewAccess">You don't have view access</div>
<section class="loader_section" *ngIf="gettingWebsiteDataLoader">
    <app-anime-loader></app-anime-loader>
</section>
